<template>
  <navbar>
    <template #logo>
      <!-- logo  -->
      <img src="@/assets/img/logo.svg">
      <h3>{{company.brand}}</h3>
    </template>
  </navbar>
  <main>
    <router-view/>
  </main>
  <Footer/>
</template>

<script setup>
import Navbar from '@core/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import company from '@/data/company.json';
import { createAppendScript } from '@core/composables/utilities';


/**
 * Add custom script in the APP
*/
const envMod = process.env.NODE_ENV;
if(envMod === 'production') {
  // New Relic
  createAppendScript('../assets/js/new_relic.js');
}  
</script>
